import requestFunctions from "../../functions/requestFunctions";

export const state = {
  REVENUE_AREA_CHART: null,
  TARGET_BAR_CHART: null,
  SALES_DONUT_CHART: null,
  TABLE_DATA: null,
  OVERVIEW_DATA: null,
  USERS_STAT_DATA: null
}

export const getters = {
  GET_REVENUE_AREA_CHART: (state) => {
    return state.REVENUE_AREA_CHART;
  },
  GET_TARGET_BAR_CHART: (state) => {
    return state.TARGET_BAR_CHART;
  },
  GET_SALES_DONUT_CHART: (state) => {
    return state.SALES_DONUT_CHART;
  },
  GET_TABLE_DATA: (state) => {
    return state.TABLE_DATA;
  },
  GET_OVERVIEW_DATA: (state) => {
    return state.OVERVIEW_DATA;
  },
  GET_USERS_STAT_DATA: (state) => {
    return state.USERS_STAT_DATA;
  }
}

export const mutations = {
  UPDATE_REVENUE_AREA_CHART(state, data) {
    if(data.revenueAreaChart) state.REVENUE_AREA_CHART = data.revenueAreaChart
  },
  UPDATE_TARGET_BAR_CHART(state, data) {
    if(data.targetsBarChart) state.TARGET_BAR_CHART = data.targetsBarChart
  },
  UPDATE_SALES_DONUT_CHART(state, data) {
    if(data.salesDonutChart) state.SALES_DONUT_CHART = data.salesDonutChart
  },
  UPDATE_TABLE_DATA(state, data) {
    if(data.tableData) state.TABLE_DATA = data.tableData;
  },
  UPDATE_OVERVIEW_DATA(state, data) {
    if(data.overviewData) state.OVERVIEW_DATA = data.overviewData
  },
  UPDATE_USERS_STAT_DATA(state, data) {
    if(data.usersStat) state.USERS_STAT_DATA = data.usersStat
  },
}

export const actions = {
  async FETCH_DASHBOARD_DATA({ commit }, payload = {}) {

    let query_url = 'https://api.brendoss-finance.insistec.ru/v1/statistics/dashboard';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_REVENUE_AREA_CHART', response.data);
      commit('UPDATE_TARGET_BAR_CHART', response.data);      
      commit('UPDATE_TABLE_DATA', response.data);
      commit('UPDATE_OVERVIEW_DATA', response.data);
      commit('UPDATE_USERS_STAT_DATA', response.data);
      commit('UPDATE_SALES_DONUT_CHART', response.data);
      return response.data;
    }
  },
}